import React from 'react';
import Lottie from 'lottie-react';

import { getEpiDataFromElement } from '../../../Utils/epiHelpers';
import RawHtml from '../../../UI/RawHtml';
import iconAnimData from '../../../AnimationFiles/dancing_pig.json';

const AnimatedUspTeaserManagedPension = (props) => {

    const text = getEpiDataFromElement('text', props.element) || '';
    const linkText = getEpiDataFromElement('link-text', props.element) || '';
    const link = getEpiDataFromElement('link', props.element) || '';
    const heading = getEpiDataFromElement('heading', props.element) || '';

    const lottieRef = React.useRef();
    
    return (
        <div className={`animated-usp-teaser animated-usp-teaser--managed-pension block-spacing`}>
            <Lottie
                autoplay={true}
                className="animated-usp-teaser__animation"
                animationData={iconAnimData}
                lottieRef={lottieRef}
            />
            <div className="animated-usp-teaser__content">
                {heading &&
                    <h2 className="animated-usp-teaser__content__title">
                        {heading}
                    </h2>
                }
                <RawHtml className="animated-usp-teaser__content__content">{text}</RawHtml>
                <a className="button button--green button--usp" href={link}>
                    <span>{linkText}</span>
                </a>
            </div>
        </div> 
     )
}

export default AnimatedUspTeaserManagedPension;

